import * as _ from 'lodash';

interface Facility {
  categorySpend: {
    last12monthSpend: number; // buyer side
    spendWithSeller: number; // seller side
  };
  savings: number;
}

export default function FilterZeroSpendAndZeroSavingsFilter() {
  return function (facilities: Facility[]) {
    return _.filter(facilities, (facility) => {
      if (
        facility.categorySpend.last12monthSpend === 0 &&
        facility.categorySpend.spendWithSeller === 0 &&
        facility.savings === 0
      ) {
        return false;
      } else {
        return true;
      }
    });
  };
}
